import { render, staticRenderFns } from "./StartseiteCard.vue?vue&type=template&id=1eb87c61&scoped=true"
import script from "./StartseiteCard.vue?vue&type=script&lang=js"
export * from "./StartseiteCard.vue?vue&type=script&lang=js"
import style0 from "./StartseiteCard.vue?vue&type=style&index=0&id=1eb87c61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb87c61",
  null
  
)

export default component.exports